import { render } from "./tabbar.vue?vue&type=template&id=2c594417&scoped=true"
import script from "./tabbar.vue?vue&type=script&lang=js"
export * from "./tabbar.vue?vue&type=script&lang=js"

import "./tabbar.vue?vue&type=style&index=0&id=2c594417&scoped=true&lang=less"

import exportComponent from "E:\\Object\\xin_poc_mini\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c594417"]])

export default __exports__